import React, { Component } from 'react';

// Components
import Login from '../../pages/login';
import { AuthProvider } from '../../authContext';

class Auth extends Component {

  constructor(props: any) {
    super(props)
    this.state = { port: null }
  }

  serialSet = (port: any) => {
    console.log("step 2", port)
    this.setState({
      port
    });
  }

  render() {
    const hasAuth = localStorage.getItem('token') !== null;
    const authProviderValue = {
      user: {
        role: localStorage.getItem('role') || '',
        name: localStorage.getItem('name') || '',
        warehouseId: localStorage.getItem('warehouseId') || '',
        partnerId: localStorage.getItem('partnerId') || '',
        sellerIds: localStorage.getItem('sellerIds') || '',
      },
      port: {
        setPort: this.serialSet,
        port: this.state.port
      }
    };
    return hasAuth ? (
      <AuthProvider value={authProviderValue}>
        {this.props.children}
      </AuthProvider>
    ) : (
      <Login />
    );
  }
}

export default Auth;
